import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as NotificationsSvg } from './assets/notifications.svg';

const NotificationsIcon = React.forwardRef((args, ref) => <SvgIcon component={NotificationsSvg} ref={ref} {...args} />);

export default NotificationsIcon;
